import { render, staticRenderFns } from "./ChooseSeatsView.vue?vue&type=template&id=d9239a52"
import script from "./ChooseSeatsView.vue?vue&type=script&lang=ts"
export * from "./ChooseSeatsView.vue?vue&type=script&lang=ts"
import style0 from "./ChooseSeatsView.vue?vue&type=style&index=0&id=d9239a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports